import { StateStorage } from "zustand/middleware";
import { dbHelpers } from "./db";

export const createIndexedDBStorage = (): StateStorage => ({
  getItem: async (name: string): Promise<string | null> => {
    try {
      const profile = await dbHelpers.getProfile();
      return profile ? JSON.stringify(profile) : null;
    } catch (error) {
      console.error("Error reading profile from IndexedDB:", error);
      return null;
    }
  },
  setItem: async (name: string, value: string): Promise<void> => {
    try {
      const profile = JSON.parse(value);
      await dbHelpers.updateProfile(profile);
    } catch (error) {
      console.error("Error writing profile to IndexedDB:", error);
    }
  },
  removeItem: async (name: string): Promise<void> => {
    try {
      await dbHelpers.updateProfile(null);
    } catch (error) {
      console.error("Error removing profile from IndexedDB:", error);
    }
  },
});
